export default [
  {
    title: 'Сначала непроверенные',
    field: 'status.desc',
    options: {
      by: 'status',
      order: 'desc'
    }
  },
  {
    title: 'Сначала проверенные',
    field: 'status.asc',
    options: {
      by: 'status',
      order: 'asc'
    }
  },
  {
    title: 'Рейтинг по возрастанию',
    field: 'stars.asc',
    options: {
      by: 'stars',
      order: 'asc'
    }
  },
  {
    title: 'Рейтинг по убыванию',
    field: 'stars.desc',
    options: {
      by: 'stars',
      order: 'desc'
    }
  },
]